import { render, staticRenderFns } from "./del-buttons.vue?vue&type=template&id=54d2d1ea&scoped=true&"
import script from "./del-buttons.vue?vue&type=script&lang=js&"
export * from "./del-buttons.vue?vue&type=script&lang=js&"
import style0 from "./del-buttons.vue?vue&type=style&index=0&id=54d2d1ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d2d1ea",
  null
  
)

export default component.exports